import React from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components";
import Footer from "../views/Layout/Footer";
import Navbar from "../views/Layout/Navbar";

interface Props {}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
`;

const Wrapper = styled.div`
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  position: relative;
`;

const Container = styled.div`
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  position: relative;
`;

const Content = styled.div`
  flex: 1 1 auto;
  width: 100%;
  max-width: 100vw;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  -webkit-overflow-scrolling: touch;
  padding-top: 65px;
`;

const MainLayout: React.FC<Props> = (props) => {
  return (
    <Root>
      <Navbar />
      <Wrapper>
        <Container>
          <Content>
            <Outlet />
          </Content>
        </Container>
      </Wrapper>
      <Footer />
    </Root>
  );
};

export default MainLayout;
